<template>
  <div
    class="flex flex-col md:flex-row items-center justify-between cursor-pointer"
    @click="openExplanationDialog"
  >
    <div class="flex w-full md:w-auto items-center gap-3 md:gap-4">
      <p
        class="font-bold text-[16px] md:text-[20px] leading-[150%] md:leading-[120%] text-base_white"
      >
        {{
          props.place == 'page'
            ? $t(`${props.grade.value}.name`)
            : $t(`${props.grade.reviewType}.name`)
        }}
      </p>
      <p
        class="text-[14px] md:text-[18px] font-medium leading-[150%] md:leading-[130%] text-[-0.28px] md:tracking-[-0.36px] text-neutral_200"
      >
        {{
          props.place == 'page'
            ? props.grade.avgScore <= 2.5
              ? `${$t(`${props.grade.value}.worstRating`)}`
              : `${$t(`${props.grade.value}.bestRating`)}`
            : props.grade.reviewScore <= 2.5
              ? `${$t(`${props.grade.reviewType}.worstRating`)}`
              : `${$t(`${props.grade.reviewType}.bestRating`)}`
        }}
      </p>
    </div>
    <div class="flex w-full md:w-auto items-center justify-between md:justify-start md:gap-2">
      <!-- <ClientOnly>
        <StarRating
          :star-size="12"
          :padding="4"
          inactive-color="#fff"
          active-color="#86C232"
          :read-only="true"
          :show-rating="false"
          :rating="props.place == 'page' ? props.grade.avgScore : props.grade.reviewScore"
        />
      </ClientOnly> -->
      <BoneRating
        :rating="props.place == 'page' ? props.grade.avgScore : props.grade.reviewScore"
      />
      <p class="text-[12px] text-base_white font-medium">
        {{
          props.place == 'page'
            ? props.grade.avgScore.toFixed(1)
            : props.grade.reviewScore.toFixed(1)
        }}
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
// import StarRating from 'vue-star-rating';
import { useDialogStore } from '~/store/dialogStore';

const props = defineProps({
  grade: {
    type: Object,
    required: true
  },
  place: {
    type: String,
    default: 'page'
  }
});
const router = useRouter();
const route = useRoute();
const dialogStore = useDialogStore();
const { t } = useI18n();
const localePath = useLocalePath();

const openExplanationDialog = () => {
  dialogStore.createConfirmationDialog(
    `${props.place == 'page' ? t(`${props.grade.value}.name`) : t(`${props.grade.reviewType}.name`)}`,
    `${props.place == 'page' ? t(`${props.grade.value}.description`) : t(`${props.grade.reviewType}.description`)}`,
    `${t('gradeAndCommentBettingShop')}`,
    undefined,
    () => {
      router.push({ path: localePath(route.path), query: { review: true as any } });
    }
  );
};
</script>
